<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'deviceModelId'
        label= '模型ID'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'
        width= '140'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>
      <el-table-column
        prop= 'paramName'
        label= '参数名'
        width= '220'>
      </el-table-column>
      <el-table-column
        prop= 'queryTime'
        label= '定时查询'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'dataType'
        label= '数据类型'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='primary' size='small' v-if="scope.row.dataType==='string'">字符串</el-button>
          <el-button type='success' size='small' v-if="scope.row.dataType==='integer'">整数</el-button>
          <el-button type='info' size='small' v-if="scope.row.dataType==='float'">小数</el-button>
          <el-button type='warn' size='small' v-if="scope.row.dataType==='enmu'">枚举</el-button>
          <el-button type='danger' size='small' v-if="scope.row.dataType==='boolean'">布尔</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'required'
        label= '是否必须'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='danger' size='small' v-if="scope.row.required===1">是</el-button>
          <el-button type='info' size='small' v-if="scope.row.required===0">否</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'resetToDefalutVal'
        label= '重启是否恢复默认状态'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='danger' size='small' v-if="scope.row.resetToDefalutVal===1">是</el-button>
          <el-button type='info' size='small' v-if="scope.row.resetToDefalutVal===0">否</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'icon'
        label= '图标'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'sort'
        label= '排序(降序)'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'method'
        label= '数据权限'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='primary' size='small' v-if="scope.row.method==='R'">只读</el-button>
          <el-button type='info' size='small' v-if="scope.row.method==='W'">只写</el-button>
          <el-button type='danger' size='small' v-if="scope.row.method==='RW'">读写</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'min'
        label= '值规则'
        width= '420'>
        <template slot-scope='scope'>
          <el-row v-if="scope.row.dataType==='integer'||scope.row.dataType==='float'">最小值:{{ scope.row.min }} 最小值:{{ scope.row.max }} 步长:{{ scope.row.step }} 默认值:{{ scope.row.defalutVal }} 单位:{{ scope.row.unit }}</el-row>
          <el-row v-if="scope.row.dataType==='string'">长度:{{ scope.row.maxLength }} 默认值:{{ scope.row.defalutVal }}</el-row>
          <el-row v-if="scope.row.dataType==='enmu'">值范围:{{ scope.row.enmuList }} 默认值:{{ scope.row.defalutVal }}</el-row>
          <el-row v-if="scope.row.dataType==='boolean'">默认值:{{ scope.row.defalutVal }}</el-row>
        </template>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" :modal="false" top="20px" width="80%">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="模型ID" :label-width="formLabelWidth" prop="deviceModelId">
          <el-input type="number" v-model.number="form.deviceModelId" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="参数名" :label-width="formLabelWidth" prop="paramName">
              <el-input v-model="form.paramName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" prop="required">
            <el-form-item label="是否必须" :label-width="formLabelWidth" prop="required">
              <el-radio v-model="form.required" :label=1>是</el-radio>
              <el-radio v-model="form.required" :label=0>否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="协议功能码" :label-width="formLabelWidth" prop="functionCode">
              <el-input type="text" v-model="form.functionCode" autocomplete="off" placeholder="485协议功能码,16进制，出现查询和控制码不一样，使用控制码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="数据类型" :label-width="formLabelWidth" prop="dataType">
              <el-select v-model="form.dataType" placeholder="请选择">
                <el-option v-for="item in optionsDataType" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="指令类型" :label-width="formLabelWidth" prop="method">
              <el-select v-model="form.method" placeholder="请选择">
                <el-option v-for="item in optionsMethod" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="着重展示" :label-width="formLabelWidth" prop="indexShow">
              <el-radio v-model="form.indexShow" :label=1>展示</el-radio>
              <el-radio v-model="form.indexShow" :label=0>不展示</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="定时查询" :label-width="formLabelWidth" prop="queryTime">
              <el-input type="number" v-model="form.queryTime" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.method=='W'||form.method=='RW'">
            <el-form-item label="控制最小间隔" :label-width="formLabelWidth" prop="minControlTime">
              <el-input type="number" v-model="form.minControlTime" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="form.method=='W'||form.method=='RW'">
            <el-form-item label="重启操作" :label-width="formLabelWidth" prop="indexShow">
              <el-radio v-model="form.resetToDefalutVal" :label=1>恢复默认状态</el-radio>
              <el-radio v-model="form.resetToDefalutVal" :label=0>不恢复默认状态</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.dataType==='integer'||form.dataType==='float'">
          <el-col :span="12">
            <el-form-item label="最小值" :label-width="formLabelWidth" prop="min">
              <el-input type="number" v-model.number="form.min" autocomplete="off" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最大值" :label-width="formLabelWidth" prop="max">
              <el-input type="number" v-model.number="form.max" autocomplete="off" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="form.dataType==='string'">
            <el-form-item label="最大长度" :label-width="formLabelWidth" prop="maxLength">
              <el-input type="number" v-model.number="form.maxLength" autocomplete="off" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="枚举用,分割" :label-width="formLabelWidth" v-if="form.dataType==='enmu'">
          <el-input v-model="form.enmuList" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="单位" :label-width="formLabelWidth" prop="unit">
              <el-input v-model="form.unit" autocomplete="off" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="属性类型" :label-width="formLabelWidth" prop="type">
              <el-select v-model="form.type" placeholder="请选择">
                <el-option v-for="item in types" :key="item.val" :label="item.descr" :value="item.val"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排序(降序)" :label-width="formLabelWidth" prop="sort">
              <el-input type="number" v-model="form.sort" autocomplete="off" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="默认值" :label-width="formLabelWidth" prop="defalutVal">
              <el-input v-model="form.defalutVal" autocomplete="off" placeholder="不需要则不需要填写"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="form.method=='W'||form.method=='RW'">
            <el-form-item label="关闭-值" :label-width="formLabelWidth" prop="closeVal">
              <el-input v-model="form.closeVal" autocomplete="off" placeholder="不需要则不需要填写"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="form.method=='W'||form.method=='RW'">
            <el-form-item label="开启-值" :label-width="formLabelWidth" prop="openVal">
              <el-input v-model="form.openVal" autocomplete="off" placeholder="不需要则不需要填写"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="form.method=='W'||form.method=='RW'">
            <el-form-item label="停止-值" :label-width="formLabelWidth" prop="stopVal">
              <el-input v-model="form.stopVal" autocomplete="off" placeholder="不需要则不需要填写"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述" :label-width="formLabelWidth" prop="descr">
          <el-input v-model="form.descr" autocomplete="off" type="textarea" :rows="4"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  props: {
    deviceModelId: {
      type: Number,
      default: 0,
      required: false
    }
  },
  watch: {
    deviceModelId: {
      handler (newV, oldV) {
        this.form.deviceModelId = this.deviceModelId
        console.log(this.form)
        this.query()
      },
      immediate: true
    }
  },
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      types: [],
      form: {
        id: null,
        addTime: null,
        upTime: null,
        name: null,
        descr: null,
        deviceModelId: null,
        paramName: null,
        dataType: null,
        required: null,
        icon: null,
        method: null,
        min: null,
        max: null,
        maxLength: null,
        step: null,
        enmuList: null,
        unit: null,
        defalutVal: null,
        queryTime: 30,
        sort: 0,
        openVal: null,
        closeVal: null,
        functionCode: null,
        stopVal: null
      },
      rules: {
        name: [{ required: true, message: '名称 不能为空', trigger: ['change', 'blur'] }, { message: '名称 长度范围:[0,255]', min: 0, max: 255, trigger: ['change', 'blur'] }],
        deviceModelId: [{ type: 'number', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '模型ID 不能为空', trigger: ['change', 'blur'] }],
        paramName: [{ required: true, message: '参数名 不能为空', trigger: ['change', 'blur'] }, { message: '参数名 长度范围:[0,64]', min: 0, max: 64, trigger: ['change', 'blur'] }],
        dataType: [{ required: true, message: '数据类型 不能为空', trigger: ['change', 'blur'] }, { message: '数据类型 长度范围:[0,64]', min: 0, max: 64, trigger: ['change', 'blur'] }],
        required: [{ type: 'number', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '是否必须 不能为空', trigger: ['change', 'blur'] }],
        method: [{ required: true, message: '数据权限  R/W/RW 不能为空', trigger: ['change', 'blur'] }, { message: '数据权限  R/W/RW 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }],
        min: [{ type: 'number', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        max: [{ type: 'number', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        maxLength: [{ type: 'number', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        step: [{ type: 'number', message: '需要小数数据类型', trigger: ['change', 'blur'] }],
        sort: [{ required: true, message: '排序 不能为空', trigger: ['change', 'blur'] }],
        queryTime: [{ required: true, message: '查询时间 不能为空', trigger: ['change', 'blur'] }],
        minControlTime: [{ required: true, message: '查询时间 不能为空', trigger: ['change', 'blur'] }],
        defalutVal: [{ required: true, message: '默认值时间 不能为空', trigger: ['change', 'blur'] }],
        indexShow: [{ type: 'number', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '是否必须 不能为空', trigger: ['change', 'blur'] }],
        resetToDefalutVal: [{ type: 'number', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '是否恢复默认状态 不能为空', trigger: ['change', 'blur'] }]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      optionsMethod: [{
        label: '只读',
        value: 'R'
      }, {
        label: '只写',
        value: 'W'
      }, {
        label: '读写',
        value: 'RW'
      }],
      optionsDataType: [{
        label: '字符串',
        value: 'string'
      }, {
        label: '整形',
        value: 'integer'
      }, {
        label: '小数',
        value: 'float'
      }, {
        label: '枚举',
        value: 'enmu'
      }, {
        label: '布尔',
        value: 'boolean'
      }]
    }
  },
  created () {
    this.query()
    this.queryTypes()
  },
  methods: {
    del (row) {
      let that = this
      console.log('del')
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/deviceModelProperty/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      console.log('delClose')
      document.body.click()
    },
    queryTypes () {
      let that = this
      this.types = []
      requestService.get('/dict/listByKkey?kkey=property_type', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.types = res.data.body
      })
    },
    query () {
      let that = this
      requestService.get(`/deviceModelProperty/listPage?current=${that.current}&pageSize=${that.pageSize}&deviceModelId=${that.deviceModelId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
      if (this.form.dataType === 'boolean') {
        this.form.closeVal = 'false'
        this.form.openVal = 'true'
      }
    },
    digAdd () {
      this.form = {deviceModelId: this.deviceModelId}
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      let that = this
      console.log(that.form)
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/deviceModelProperty/add'
          if (that.form.id) {
            url = '/deviceModelProperty/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/deviceModelProperty/Index.vue